import LowBatteryNotification from "./LowBatteryNotification";
import { useDevices } from "@/store/devices";
import { getViewerDevices } from "@/store/devices/selectors";
import Xmpp from "@/modules/Xmpp";

export default class Notifications {
  private static didSendLowBatteryNotification = false;

  static handleLowBatteryNotification = ({ state, level }: BatteryStatus) => {
    if (state === "CHARGING") {
      this.didSendLowBatteryNotification = false;
      return;
    }

    const isLow = state === "DISCHARGING" && level <= LowBatteryNotification.LOW_BATTERY_LEVEL;
    if (isLow && !this.didSendLowBatteryNotification) {
      this.didSendLowBatteryNotification = true;
      const payload = LowBatteryNotification.create({
        batteryLevel: level
      });
      if (!payload) return;
      const encodedPayload = LowBatteryNotification.encode(payload);
      this.sendNotification(encodedPayload);
    }
  };

  private static sendNotification = (encodedPayload: string) => {
    const viewerJids = getViewerDevices(useDevices.getState()).map((viewer) => viewer.jid);
    const xmpp = Xmpp.getInstance();
    viewerJids.forEach((jid) => xmpp.sendPushNotification(encodedPayload, jid));
  };
}
